"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var GlobalKind = /*#__PURE__*/function (GlobalKind) {
  GlobalKind["DEFAULT"] = "default";
  GlobalKind["POSITIVE"] = "positive";
  GlobalKind["WARNING"] = "warning";
  GlobalKind["CRITICAL"] = "critical";
  GlobalKind["INVERSE"] = "inverse";
  GlobalKind["EMPHASIS"] = "emphasis";
  GlobalKind["SPECIAL"] = "special";
  GlobalKind["INFORMATION"] = "information";
  return GlobalKind;
}(GlobalKind || {});
var _default = exports["default"] = GlobalKind;